import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import TrashIcon from './icons/TrashIcon.jsx';
import { useRef } from 'react';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

const DropdownButton = ({
    options,
    btnClassName,
    btnContent,
    menuItemsClassName,
    iconsFirst,
}) => {
    const menuItemsRef = useRef();

    /**
     * Make sure the bottom of the dropdown is in view
     * @param isOpen
     */
    function scrollIntoView(isOpen) {
        if (isOpen) {
            const rect = menuItemsRef.current?.getBoundingClientRect();
            if (!rect) return;

            const height = rect.height;
            const top = rect.y + window.scrollY;
            const bottom = top + height + 8;
            const windowBottom = window.innerHeight + window.scrollY;
            const bodyHeight = document.body.scrollHeight;

            if (bottom > bodyHeight && top - 20 - height > 0) {
                menuItemsRef.current.style.bottom = -20 + 'px';
            } else if (bottom > windowBottom) {
                const scrollTo = window.scrollY + bottom - windowBottom;
                window.scrollTo({ top: scrollTo, left: 0, behavior: 'smooth' });
            }
        }
    }

    function getIcon(opt)
    {
        return opt.icon ||
            (opt.isDelete ? (
                <TrashIcon className="text-red-700" />
            ) : null);
    }

    return (
        <Menu as="div" className="relative inline-block text-left">
            {({ open }) => (
                <>
                    <div>
                        <MenuButton className={btnClassName}>
                            <span className="sr-only">Open options</span>
                            {btnContent}
                        </MenuButton>
                    </div>

                    <MenuItems
                        transition
                        ref={menuItemsRef}
                        className={`absolute right-0 z-10 mt-1 w-56 overflow-hidden origin-top-right rounded-lg bg-white shadow-xl ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in ${menuItemsClassName || ''}`}
                    >
                        <div
                            className="divide-y divide-gray-200"
                            onLoad={scrollIntoView(open)}
                        >
                            {options.map((opt, idx) => (
                                <MenuItem key={idx}>
                                    {({ focus, close }) => (
                                        <a
                                            href="#"
                                            onClick={ev => {
                                                ev?.preventDefault();
                                                if (opt.onClick(ev)) {
                                                    close();
                                                }
                                            }}
                                            className={classNames(
                                                focus
                                                    ? 'bg-gray-100 text-gray-900'
                                                    : 'text-gray-700',
                                                'block no-underline px-4 py-3 text-sm flex items-start justify-between',
                                                opt.isDelete &&
                                                    'text-red-700 hover:text-red-700',
                                                iconsFirst &&
                                                    'flex-row-reverse gap-x-3',
                                                opt.className,
                                            )}
                                        >
                                            <div className="flex-1">
                                                <div>{opt.name}</div>
                                                {!!opt.description && (
                                                    <div className="text-sm text-gray-500 mt-1">
                                                        {opt.description}
                                                    </div>
                                                )}
                                            </div>
                                            {!!getIcon(opt) && (
                                                <div
                                                    className={`w-4 h-4 mt-0.5 ${iconsFirst ? 'text-primary-700' : ''}`}
                                                >
                                                    {getIcon(opt)}
                                                </div>
                                            )}
                                        </a>
                                    )}
                                </MenuItem>
                            ))}
                        </div>
                    </MenuItems>
                </>
            )}
        </Menu>
    );
};

export default DropdownButton;
